import { CardWithIcon, Heading, SvgIconProps } from '@cinch-labs/design-system'
import styles from './feature-card-rich-text.module.css'
import { StoryBlokRichText } from '@cinch-nx/data-storyblok'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'

export interface FeatureCardRichTextProps {
  title: string
  body: StoryBlokRichText
  icon: SvgIconProps['name']
}

export const FeatureCardRichText: React.FC<FeatureCardRichTextProps> = ({
  title,
  body,
  icon,
}) => (
  <div className={styles.card} aria-label="feature card">
    <CardWithIcon
      className={styles['iconContainer']}
      iconName={icon}
      iconColor="vividViolet"
      iconGradient="galaxy"
      iconSize={32}
    />
    <Heading element="h3" className={styles.title}>
      {title}
    </Heading>
    <div className={styles.body}>{renderWithResolver(body)}</div>
  </div>
)
